<h2 mat-dialog-title style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">Edit Plan</h2>
<mat-divider></mat-divider>

<app-default-progress-bar *ngIf="planDetails == null"></app-default-progress-bar>

<form *ngIf="planDetails != null" [formGroup]="planDetails">
	<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
		<div class="p-8" fxLayout="row" fxLayoutAlign="center center">
			<div fxFlex>Current Plan</div>
			<div fxFlex>{{data.accountDetails.plan}}</div>
		</div>

		<div class="p-8" fxLayout="row" fxLayoutAlign="center center">
			<mat-form-field fxFlex="100">
				<mat-select formControlName="currentPlan" name="plan" placeholder="Plan">
					<mat-option *ngFor="let plan of planNames" value="{{plan}}">{{plan}}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="p-8" fxLayout="row" fxLayoutAlign="start start">
			<mat-checkbox
				[color]=" 'primary' "
				[labelPosition]=" 'before' "
				class="fs-13"
				formControlName="freeTrial"
			>
				Free Trial duration
			</mat-checkbox>
		</div>

		<div
			*ngIf="IS_NOT_EMPTY(currentPlanMsg)"
			class="p-8"
			class="danger-text font-size-12"
			fxLayout="row"
			fxLayoutAlign="start start"
		>
			<span class="padding-0-5"> {{currentPlanMsg}} </span>
		</div>

		<div
			*ngIf="this.planDetails.get('freeTrial').value"
			class="p-8"
			fxLayout="row"
			fxLayoutAlign="center center"
		>
			<mat-form-field fxFlex="100">
				<input
					(click)="picker1.open()"
					[matDatepicker]="picker1"
					[min]="mindate"
					formControlName="freeTrialDate"
					matInput
					placeholder="Free Trial duration"
				/>
				<mat-datepicker-toggle [for]="picker1" matSuffix tabIndex="-1"></mat-datepicker-toggle>
				<mat-datepicker #picker1></mat-datepicker>
			</mat-form-field>
		</div>

		<div
			*ngIf="!planDetails.get('freeTrial').value"
			class="p-8"
			fxLayout="row"
			fxLayoutAlign="start start"
		>
			<mat-checkbox
				[color]=" 'primary' "
				[labelPosition]=" 'before' "
				class="fs-13"
				formControlName="emailUser"
			>
				Email User
			</mat-checkbox>
		</div>

		<div
			*ngIf="IS_NOT_NULL_OR_UNDEFINED(data.account.subscription.creditCardPayment)"
			class="p-8"
			fxLayout="row"
		>
			<div fxFlex>Pay by CC</div>
			<div fxFlex="20" fxLayoutAlign="end center">
				<mat-slide-toggle color="primary" formControlName="creditCardPayment"></mat-slide-toggle>
			</div>
		</div>
	</mat-dialog-content>

	<mat-divider></mat-divider>

	<mat-dialog-actions style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
		<div fxFlex="100" fxLayoutAlign="end center">
			<span (click)="closeDialog(null)" class="link m-r-1">Close</span>
			<button
				(click)="updatePlanConfirmationDialog()"
				*ngIf="!isUpdatingPlan"
				[disabled]="!isFormValueChanged()"
				color="primary"
				mat-raised-button
			>
				Update
			</button>
			<mat-spinner *ngIf="isUpdatingPlan" [diameter]="30"></mat-spinner>
		</div>
	</mat-dialog-actions>
</form>
